import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import useSeo, { ensureJsonLd } from '@/hooks/useSeo';
import { faqs } from '@/mocks/manga';

export default function Faq() {
  useSeo({
    title: '泡在我家的辣妹常见问题解答 泡在我家的辣妹漫画介绍',
    description:
      '关于《泡在我家的辣妹》漫画的常见问题解答：剧情讲什么、什么题材、主要角色、感情线进展，以及如何阅读。看漫画前先搞懂泡在我家的辣妹漫画介绍。',
    keywords: '泡在我家的辣妹常见问题,泡在我家的辣妹剧情,泡在我家的辣妹讲什么,泡在我家的辣妹漫画介绍',
    path: '/faq',
  });

  useEffect(() => {
    ensureJsonLd('ld-breadcrumb', {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://dramaquest2.github.io/' },
        { '@type': 'ListItem', position: 2, name: '常见问题', item: 'https://dramaquest2.github.io/faq' },
      ],
    });
    ensureJsonLd('ld-faq', {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    });
    return () => {
      ['ld-breadcrumb', 'ld-faq'].forEach((id) => document.getElementById(id)?.remove());
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <header className="bg-background-100">
          <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16 lg:px-8">
            <nav aria-label="面包屑" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-600">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-700">常见问题</span>
            </nav>
            <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-question-answer-line"></i>
              常见问题
            </span>
            <h1 className="mt-4 text-2xl leading-snug text-foreground-950 md:text-4xl">
              追漫前的疑惑，这里先解答
            </h1>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              关于《泡在我家的辣妹》的题材、角色、感情线与剧情走向，这里汇总了读者最常问到的几个问题，帮助你快速了解这部作品。
            </p>
          </div>
        </header>

        <section className="bg-background-50 py-12 md:py-16">
          <div className="mx-auto max-w-3xl px-4 md:px-6 lg:px-8">
            <div className="space-y-4">
              {faqs.map((f) => (
                <details key={f.q} className="group rounded-lg bg-background-100 p-5">
                  <summary className="flex cursor-pointer items-center justify-between gap-3 text-sm font-medium text-foreground-900 md:text-base">
                    {f.q}
                    <i className="ri-add-line text-xl text-foreground-500 transition-transform group-open:rotate-45"></i>
                  </summary>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                </details>
              ))}
            </div>

            <div className="mt-12 rounded-lg bg-primary-900 p-6 md:p-8">
              <h2 className="font-heading text-xl text-background-50">还有问题没找到答案？</h2>
              <p className="mt-2 text-sm text-background-200">
                如果你对剧情或角色还有疑问，欢迎通过关于本站页面的邮箱联系我们，我们会持续补充常见问题。
              </p>
              <div className="mt-5 flex flex-col gap-3 sm:flex-row">
                <Link
                  to="/about"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
                >
                  关于本站
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/plot"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
                >
                  回到剧情主线
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}